
import Api from '../classes/api';
import Lang from '../classes/lang';
import Logger from '../classes/logger';
import Config from '../classes/config';
import AppConfig from '../AppConfig';

export const appConfig = new Config(AppConfig);
export const api = new Api();
export const lang = new Lang(api);
export const logger = new Logger();